import {
  Box,
  Flex,
  Grid,
  Skeleton,
  Spinner,
  Text,
} from '@enechain/ecloud-designsystem'

/** 読み込み中に並べる仮の行数 (design `#loading` の `.up-skeleton-row` 5 本)。 */
const SKELETON_ROW_COUNT = 5

type Props = {
  /** 「サーバーで差分計算中...」等の案内。 */
  label: string
  /** 差分表の列数。 仮の行を同じ列数で並べ、 表が出た時に形が変わらないようにする。 */
  columnCount: number
}

/**
 * CSV アップロード Step2 の差分計算中の表示 (design `#loading .up-loading`)。
 * 差分表と同じ枠の中に、 左上の小さなスピナー + 案内と、 表の形をした仮の行を並べる。
 * 枠は差分表の上限 (480px) と同じ高さを取り、 結果が出た時に下の要素が跳ねないようにする。
 */
export const CsvDiffLoading = ({
  label,
  columnCount,
}: Props): React.ReactElement => (
  <Flex
    flexDirection="column"
    gap={3}
    minHeight="480px"
    marginBottom={3}
    padding={4}
    background="Surface.primary"
    borderWidth="1px"
    borderColor="Border.lowEmphasis"
    borderRadius="md"
    role="progressbar"
  >
    <Flex alignItems="center" gap={2}>
      <Spinner />
      <Text color="Text.midEmphasis" fontSize="sm">
        {label}
      </Text>
    </Flex>
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, rowIndex) => (
      <Grid
        key={rowIndex}
        gridGap={3}
        gridTemplateColumns={`repeat(${columnCount}, 1fr)`}
        borderBottomWidth="1px"
        borderBottomColor="Border.lowEmphasis"
        paddingY={2}
      >
        {Array.from({ length: columnCount }, (__, colIndex) => (
          <Box key={colIndex}>
            <Skeleton height="14px" borderRadius="base" />
          </Box>
        ))}
      </Grid>
    ))}
  </Flex>
)
